export const getUserData = () => {
  const userStr = localStorage.getItem('user');
  if (!userStr)
    return {
      currentPage: 'login',
    };
  const user = JSON.parse(userStr);
  return user;
};
